export interface ChangePwd {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

export interface EditProfileBody {
  profile_picture: string;
  role: string;
  manager_id: string;
  emp_id: string;
  user_designation: string;
  dojoining: Date;
  user_mobile: string;
  user_email: string;
  user_skypeid: string;
  doBirth: Date;
  doanniversary: Date;
  id_proof: string;
  user_first_name: string;
  user_last_name: string;
  address: string;
  address2: string;
  country: string;
  state: string;
  city: string;
  zipcode: string;
  user_department: string;
}
